import EventEmitter from 'eventemitter3';

/**
 * Shutter dom classes
 * @type {{CONTAINER: string, HANDLER: string, SHUTTER: string, INNER: string}}
 */
export const shutterSelectors = {
    CONTAINER: 'shutter-container',
    HANDLER: 'shutter-handler',
    SHUTTER: 'shutter',
    INNER: 'shutter-inner'
};

/**
 * Shutter open/close panel on handler click/hover
 *
 * Example :
 * <div class="shutter-container" data-handler-type="hover">
 *     <div class="shutter-handler"></div>
 *     <div class="shutter">
 *         <div class="shutter-inner">
 *             ...content here
 *         </div>
 *     </div>
 * </div>
 *
 */
export default class Shutter extends EventEmitter {
    /**
     *  Create a shutter
     * @param {boolean} initOpen - Is shutter open on init
     * @param {string} handlerType - How the shutter open (values: 'click', 'hover')
     * @param {string} containerSelector - Selector for container dom element
     * @param {string} handlerSelector - Selector for handler dom element
     * @param {string} shutterSelector - Selector for shutter dom element
     * @param {string} innerSelector - Selector for inner dom element
     * @constructor
     */
    constructor({
            initOpen = false,
            handlerType = 'click',
            containerSelector = '.' + shutterSelectors.CONTAINER,
            handlerSelector = '.' + shutterSelectors.HANDLER,
            shutterSelector = '.' + shutterSelectors.SHUTTER,
            innerSelector = '.' + shutterSelectors.INNER,
        } = {}) {
        super();

        // Dom elements
        this.initOpen = initOpen;
        this.handlerType = handlerType;
        this.containerSelector = containerSelector;
        this.handlerSelector = handlerSelector;
        this.shutterSelector = shutterSelector;
        this.innerSelector = innerSelector;
        this.shutterLock = false;

        this.init();
    }

    /**
     * Shutter height
     * @return {number}
     */
    get shutterHeight() {
        return this.dom.shutterInner.offsetHeight;
    }

    /**
     * init shutter
     */
    init() {
        this._retrieveDOM();
        this._getHandlerType();
        this._setDefaultClasses();

        // open on init
        if (this.initOpen) this.openPan();

        // hover handlers
        if(this.handlerType === 'hover') {
            this.dom.container.addEventListener('mouseenter', this.openPan.bind(this));
            this.dom.container.addEventListener('mouseleave', this.closePan.bind(this));
            this.dom.container.addEventListener('click', () => {
                this.openPan();
                this.shutterLock = !this.shutterLock;
            });

        // click handlers
        } else {
            this.dom.shutterHandler.addEventListener('click', this._handleState.bind(this));
        }
    }

    /**
     * Open the pan
     * @fires Shutter#open
     */
    openPan() {
        this.dom.container.classList.add('open');
        this.dom.shutter.style.maxHeight = this.shutterHeight + 'px';
        this.emit('open');
    }

    /**
     * Close the pan
     * @fires Shutter#close
     */
    closePan() {
        if(this.shutterLock) return;
        this.dom.shutter.style.maxHeight = 0;
        this.dom.container.classList.remove('open');
        this.emit('close');
    }

    /**
     * get handler type from dom element data attribute
     * @private
     */
    _getHandlerType() {
        if(this.dom.container.dataset.handlerType && this.dom.container.dataset.handlerType.length > 0)
            this.handlerType = this.dom.container.dataset.handlerType
    }

    /**
     * get dom elements from selectors
     * @private
     */
    _retrieveDOM() {
        this.dom = {};
        this.dom.container = document.body.querySelector(this.containerSelector);
        this.dom.shutter = this.dom.container.querySelector(this.shutterSelector);
        this.dom.shutterInner = this.dom.container.querySelector(this.innerSelector);
        this.dom.shutterHandler = this.dom.container.querySelector(this.handlerSelector);
    }

    /**
     * Set default dom classes
     * @private
     */
    _setDefaultClasses() {
        this.dom.container.classList.add(shutterSelectors.CONTAINER);
        this.dom.shutter.classList.add(shutterSelectors.SHUTTER);
        this.dom.shutterInner.classList.add(shutterSelectors.INNER);
        this.dom.shutterHandler.classList.add(shutterSelectors.HANDLER);
    }

    /**
     * Handle open/close state
     * @param {Event} e - Event object
     * @private
     */
    _handleState(e) {
        //var handler = e.target;
        e.preventDefault();
        if(!this.dom.container.classList.contains('open')) {
            this.openPan();
        } else {
            this.closePan();
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/helpers/shutter.js